import { useCustomQuery } from '@/global/hooks/useCustomQuery';
import { schoolLogsService } from '@/global/api/gen';
import type {
    SchoolLogsControllerSearchSchoolsQueryParams
} from '@/global/api/gen/ts/school-logsDTO/SchoolLogsControllerSearchSchools';
import { SchoolLogsKeys } from '@/modules/school-logs/shared/services/school-logs.keys';

export const apiSchoolLogs = (schoolId: number, params: SchoolLogsControllerSearchSchoolsQueryParams) => {
    return useCustomQuery({
        enabled: !!schoolId && !isNaN(schoolId),
        queryFn: () => schoolLogsService.schoolLogsControllerSearchSchools({schoolId}, params)
            .then((res) => res.data),
        queryKey: SchoolLogsKeys.searchSchoolLogs(params, schoolId)
    });
};